







































































import Vue from 'vue'

import Bookmark from '@/components/bookmark/bookmark.vue'
import VMarkdown from '@/components/v-markdown/v-markdown.vue'
import CorrectIcon from '@/components/correct-icon/correct-icon.vue'
import VButton from '@/components/button/basic-button.vue'
import QuestionOption from './QuestionOption.vue'

import { ANSWER_TYPE } from '@/lib/definitions'
import { indexToLabel } from '@/lib/functions'

interface Data {
  showSolution: boolean
}

export default Vue.extend({
  name: 'Page',

  props: {
    question: {
      type: Object as Prop<api.unitImpl.Question>,
      required: true
    },
    isNormalExam: {
      type: Boolean as Prop<boolean>,
      required: true
    },
    isMobile: {
      type: Boolean as Prop<boolean>,
      required: true
    },
    showSecondSwipeBtn: {
      type: Boolean as Prop<boolean>,
      required: true
    }
  },

  components: {
    Bookmark,
    VMarkdown,
    QuestionOption,
    CorrectIcon,
    VButton
  },

  data(): Data {
    return {
      showSolution: false
    }
  },

  created() {
    window.addEventListener('keypress', this.enterByKey)
  },
  mounted() {
    this.$nextTick(() => {
      this.checkShowSecondSwipeBtn()
    })
    window.addEventListener('scroll', this.checkShowSecondSwipeBtn)
  },
  destroyed() {
    window.removeEventListener('keypress', this.enterByKey)
    window.removeEventListener('scroll', this.checkShowSecondSwipeBtn)
  },

  computed: {
    checkAnswer() {
      let allCorrect = false
      let result: any[] = []

      this.question.options.forEach(answer => {
        if (answer.right_or_wrong) {
          result.push(answer.seq)
        }
      })

      if (result.length === this.question.impl.answers.length) {
        allCorrect = true
        result.forEach(test => {
          if (this.question.impl.answers.includes(test) === false) {
            allCorrect = false
            return
          }
        })
      }

      return allCorrect
    }
  },

  methods: {
    indexToLabel,

    clickOption(event: any) {
      // 単一選択の場合は他の選択肢を削除する
      if (this.question.answer_type === ANSWER_TYPE.Single) {
        this.question.impl.answers.splice(
          this.question.impl.answers.indexOf(0),
          1
        )
      }

      const elm = document.getElementsByClassName('answer-checkbox')
      // @ts-ignore
      elm.forEach(e => {
        e.blur()
      })
    },

    clickBookmarkIcon() {
      this.$emit('update-bookmark', this.question)
    },

    clickShowAnswerResultButton() {
      this.$emit('click-show-answer-result')
    },

    clickFeedbackLink() {
      this.$emit('click-feedback', this.question.id)
    },

    enterByKey(e: any) {
      let inputKey = String.fromCharCode(e.keyCode).toLowerCase()

      // 選択肢のラベルを取得（[A, B, C, D, ...]）
      let choiceLabels = this.question.options.map((_, index) =>
        this.indexToLabel(index).toLowerCase()
      )

      for (let i = 0; i < choiceLabels.length; i++) {
        if (inputKey === choiceLabels[i]) {
          // 複数選択の場合
          if (this.question.answer_type === 'multiple_choice') {
            // 回答が選択済みの場合は
            if (this.question.impl.answers.includes(i + 1)) {
              // 回答を取り除く
              this.question.impl.answers.splice(
                this.question.impl.answers.indexOf(i + 1),
                1
              )
            } else {
              // 回答を追加
              this.question.impl.answers.push(i + 1)
            }
          } else {
            // 単一選択の場合
            // 未回答の場合
            if (this.question.impl.answers.includes(i + 1)) {
              // 既存の回答を取り除く
              this.question.impl.answers.splice(
                this.question.impl.answers.indexOf(i + 1),
                1
              )
            } else {
              // 既存の回答を取り除く
              this.question.impl.answers.splice(
                this.question.impl.answers.indexOf(i + 1),
                1
              )
              // 回答を追加
              this.question.impl.answers.push(i + 1)
            }
          }
        }
      }
    },

    // 二つ目のスライドボタンを表示するかどうかをチェックする
    checkShowSecondSwipeBtn() {
      const questionsEl = this.$el.querySelector('.questions') as HTMLElement

      if (questionsEl) {
        const rect = questionsEl.getBoundingClientRect()

        const show = rect.bottom < window.innerHeight / 2 - 100
        if (show !== this.showSecondSwipeBtn) {
          this.$emit('updateShowSecondSwipeBtn', show)
        }
      }
    }
  }
})
